import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import ApiError from '../../../components/Errors/ApiError';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
import ContentViewport from '../../../components/ContentViewport';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_CLASS_NAME = 'exam-error-screen';
const ExamErrorScreen = ({
  error
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(ContentViewport, {
    paddingClassName: `${BASE_CLASS_NAME}__content`,
    children: /*#__PURE__*/_jsx(ApiError, {
      error: error
    })
  }), /*#__PURE__*/_jsx(ContentControlWrapper, {
    className: `${BASE_CLASS_NAME}__content-control`,
    children: /*#__PURE__*/_jsx(UIButton, {
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.examQuestion.nextButton"
      })
    })
  })]
});
export default ExamErrorScreen;